import { Injectable } from '@angular/core';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { map, switchMap, catchError, mergeMap } from 'rxjs/operators';
import { RootStoreState } from '..';
import { Store } from '@ngrx/store';
import { StopList } from '../../modal';

import * as ActionStopList from './action';

@Injectable()
export class StopListEffects {
  constructor(private store: Store<RootStoreState.State>, private actions$: Actions) {}

  @Effect()
  loadAction$ = this.actions$
    .pipe(
      ofType<ActionStopList.PostStopListRequest>(ActionStopList.POST_StopList),
      map(action => {return action.payload}),
      
    );
  private handleError(error) {
    return of(new ActionStopList.Error(error));
  }
}
